module.exports = "<div mat-dialog-content style=\"text-align: center\">\r\n  <p>You wallet balance is below RM 500</p>\r\n  <p>Please Reload</p>\r\n</div>\r\n"